module.exports = __webpack_public_path__ + "static/media/1011077.025a0b3a.jpg";